module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousFFView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("EDI TEAM Execution (" + _vm._s(_vm.EdiExecutionModel.ccType) + ")")]), _vm._v(" "), (_vm.EdiExecutionModel.ccType == 'Import') ? _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [(_vm.mainEntryData[0].shippingArrivalNoticmailSentDate == null) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.SendShipmentArrival
    }
  }, [_vm._v("Send Shipment Arrival Notice")]) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": this.ALLMODULE ? this.ALLMODULE : '',
      "jobSeriesBanner": this.JOBSERIES ? this.JOBSERIES : '',
      "bannerClientName": this.EXPORTER ? this.EXPORTER : '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "dark"
    },
    on: {
      "click": _vm.showDocModal
    }
  }, [_vm._v("Upload SB Documents")]), _vm._v(" "), _c('div', [(_vm.ALLMODULE) ? _c('container-component', {
    attrs: {
      "allModuleIdContainer": _vm.ALLMODULE,
      "JOB": "CC",
      "TYPE": _vm.TYPE == 'Import' ? 'IMPORT' : ''
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.proceedNext == '1') ? _c('div', [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.EdiExecutionModel.vgmBy == 'SHIPPER') ? _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [(_vm.EdiExecutionModel.vgmBy == 'SHIPPER') ? _c('b-button', {
    staticStyle: {
      "margin-top": "35px !important"
    },
    attrs: {
      "size": "sm",
      "variant": "dark"
    },
    on: {
      "click": _vm.showDocModal
    }
  }, [_vm._v("Upload Shipper VGM")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.viewVgmDoc.length > 0 || _vm.viewVgmDoc.length > 0) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, _vm._l((_vm.viewVgmDoc), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "100"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "45"
      }
    }), _vm._v(" "), (_vm.EdiExecutionModel.ccType == 'Export') ? _c('a', {
      attrs: {
        "href": _vm.docURL + "/CC_Export_Uploads/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))]) : _c('a', {
      attrs: {
        "href": _vm.docURL + "/CC_Import_Uploads/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))])], 1)
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_c('div', [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderBL"
    },
    on: {
      "click": function($event) {
        _vm.emailChecklist('0')
      }
    }
  }, [_vm._v("Save & Submit\n                ")])], 1), _vm._v(" "), _c('div', [(_vm.EdiExecutionModel.ccType == 'Export') ? _c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderHand"
    },
    on: {
      "click": function($event) {
        _vm.emailChecklist('handover')
      }
    }
  }, [_vm._v(_vm._s(_vm.portType == "Sea_Port" ?
    "Save & Proceed to Gate-in-at Terminal by Road" :
    "Save & Proceed to Handover"))]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderHand"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderVGM"
    },
    on: {
      "click": function($event) {
        _vm.emailChecklist('PAYTEST')
      }
    }
  }, [_vm._v("Save & Proceed S-Line Payment")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderVGM"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [(_vm.EdiExecutionModel.ccType == 'Export') ? _c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderBL"
    },
    on: {
      "click": function($event) {
        _vm.emailChecklist('BL')
      }
    }
  }, [_vm._v("Save & Proceed to BL")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderBL"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [(_vm.EdiExecutionModel.ccType == 'Import') ? _c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderVgm"
    },
    on: {
      "click": function($event) {
        _vm.emailChecklist('vgm')
      }
    }
  }, [_vm._v("Save & Proceed To Execution")]) : _vm._e(), _vm._v(" "), (
    _vm.EdiExecutionModel.ccType == 'Export' &&
    _vm.EdiExecutionModel.vgmBy != 'SHIPPER'
  ) ? _c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderVgm"
    },
    on: {
      "click": function($event) {
        _vm.emailChecklist('vgm')
      }
    }
  }, [_vm._v("Save & Proceed To VGM")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderVgm"
    }
  })], 1), _vm._v(" "), _c('div')], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.ALLMODULE) ? _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": ""
    }
  }, [_c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n      ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-dialog-alert', {
    ref: "alertAddSeaImp",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.Onclose
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "message",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-583d9a7e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/CCImport/newEdiExecution.vue
// module id = 2654
// module chunks = 0